/**
 * Text formatting utilities
 * Centralized text transformation functions used across the application
 */

/**
 * Capitalize first letter, lowercase the rest
 * @param {string} str - String to capitalize
 * @returns {string} Capitalized string, or empty string if input is null/undefined
 */
export const capitalize = (str) => {
  if (!str || typeof str !== 'string') return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * Alias for capitalize (used in some components)
 * @param {string} str - String to convert to title case
 * @returns {string} Title cased string
 */
export const toTitleCase = capitalize;
